import { NaviIndication } from '@craif/product.entities.navi_result'
import { ViewModel } from '@craif/product.view_models.base'
import { NaviSample } from 'entities/navi_sample'

export class NaviSampleViewModal extends ViewModel<NaviSample> {
    public convertNaviCancerName = (): string[] => {
        const naviIndications = this.object.naviProduct?.naviIndications
        if (!naviIndications) {
            return []
        }

        const cancerNamesJaList = naviIndications.map((i: NaviIndication) => {
            switch (i.name) {
                case 'lung':
                    return '肺がん'
                case 'stomach':
                    return '胃がん'
                case 'colorectal':
                    return '大腸がん'
                case 'pancreas':
                    return 'すい臓がん'
                case 'esophagus':
                    return '食道がん'
                case 'ovary':
                    return this.object.patient?.gender === 'FEMALE' ? '卵巣がん' : ''
                case 'breast':
                    return this.object.patient?.gender === 'FEMALE' ? '乳がん' : ''
                default:
                    return ''
            }
        })
        return cancerNamesJaList.filter((name) => name !== '')
    }
}
